module.exports = __webpack_public_path__ + "d14.no2.238296f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d14.no2.jpg
// module id = 36Qr
// module chunks = 0